import { Col } from "react-bootstrap";
import { Box, Group, Text, Card, Image } from "@mantine/core";
import { Link } from "react-router-dom";

import { IconExternalLink } from "@tabler/icons-react";

export const ProductCardsJSX = ({ cardsArray }) => {
  const CardArry = cardsArray.map((product, index) => (
    <Col key={index} lg={4} md={8} sm={12}>
      <Card shadow="sm" padding="xl" component="a" href={product.link} my="md">
        <Card.Section>
          <Image src={product.image} alt={product.title} loading="lazy" width={product.width}/>
        </Card.Section>
        <Card.Section>
          <div className="our-products-content p-2">
            <Group w={"100%"}>
              <h3 className="my-2">{product.title}</h3>
              <Box className="our-products-icons">{product.icon}</Box>
            </Group>
            <div className={product.buttonClass}>
              <Link to={product.link}>
                <Group align="center" gap="xs">
                  <Text fs={"14px"}>Explore Now</Text>
                  <IconExternalLink size={"14"} color="#666666" />
                </Group>
              </Link>
            </div>
          </div>
        </Card.Section>
      </Card>
    </Col>
  ));
  return CardArry;
};

// Usage in your component:
// {ProductCardsJSX}
